import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseEdit: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93933 21.0606C2.5847 20.706 2.43076 20.1976 2.52912 19.7058L3.52912 14.7058C3.5872 14.4154 3.72993 14.1487 3.93933 13.9393L15.2322 2.64642C16.2085 1.67011 17.7914 1.67011 18.7678 2.64642L21.3535 5.2322C22.3299 6.20851 22.3299 7.79143 21.3535 8.76774L10.0607 20.0606C9.85125 20.27 9.58455 20.4128 9.29417 20.4708L4.29417 21.4708C3.80238 21.5692 3.29397 21.4153 2.93933 21.0606ZM4.31868 18.4065L3.99999 20L5.59344 19.6813L8.11611 19.1767L4.82322 15.8839L4.31868 18.4065ZM18.4697 9.5303L9.53032 18.4696L5.53032 14.4696L14.4697 5.5303L18.4697 9.5303ZM19.5303 8.46964L20.2929 7.70708C20.6834 7.31655 20.6834 6.68339 20.2929 6.29286L17.7071 3.70708C17.3166 3.31655 16.6834 3.31655 16.2929 3.70708L15.5303 4.46964L19.5303 8.46964Z"
        fill={color}
      />
    </svg>
  );
};
